import { render, staticRenderFns } from "./AlertListScreen.vue?vue&type=template&id=23fbde77&scoped=true&lang=pug"
import script from "./AlertListScreen.vue?vue&type=script&lang=ts"
export * from "./AlertListScreen.vue?vue&type=script&lang=ts"
import style0 from "./AlertListScreen.vue?vue&type=style&index=0&id=23fbde77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fbde77",
  null
  
)

export default component.exports